import ImageOne from '../assets/img/ImageOne.jpg'
import ImageTwo from '../assets/img/ImageTwo.jpg'
import ImageThree from '../assets/img/ImageThree.jpg'
import ImageFour from '../assets/img/ImageFour.jpg'
import ImageFive from '../assets/img/ImageFive.jpg'
import ImageSix from '../assets/img/ImageSix.jpg'
import ImageSeven from '../assets/img/ImageSeven.jpg'


export const SliderData = [
    {
        title: 'Villa luxieuse à Bali, Indonésie',
        price: '4 280 000 €',
        path: '/location/1',
        label: 'Détails du bien',
        image: ImageOne,
        alt: 'Villa luxieuse à Bali, Indonésie'
    },
    {
        title: 'Maison à San Jose, Costa Rica',
        price: '2 860 000 €',
        path: '/location/2',
        label: 'Détails du bien',
        image: ImageTwo,
        alt: 'Maison à San Jose, Costa Rica'
    },
    {
        title: 'Maison à Calabasas, Californie',
        price: '8 420 000 €',
        path: '/location/3',
        label: 'Détails du bien',
        image: ImageThree,
        alt: 'Maison à Calabasas, Californie'
    },
    {
        title: 'Maison à Houston, Texas',
        price: '6 660 000 €',
        path: '/location/4',
        label: 'Détails du bien',
        image: ImageFour,
        alt: 'Maison à Houston, Texas'
    },
    
    {
        title: 'Maison à Las Vegas, Nevada',
        price: '8 980 000 €',
        path: '/location/5',
        label: 'Détails du bien',
        image: ImageFive,
        alt: 'Maison à Las Vegas, Nevada'
    },
    {
        title: 'Maison à Houston, Texas',
        price: '3 460 000 €',
        path: '/location/6',
        label: 'Détails du bien',
        image: ImageSix,
        alt: 'Maison à Houston, Texas'
    },
    {
        title: 'Maison à Alajuela, Costa Rica',
        price: '5 420 000 €',
        path: '/location/7',
        label: 'Détails du bien',
        image: ImageSeven,
        alt: 'Maison à Alajuela, Costa Rica'
    },
];
